import React, { useEffect, useState } from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

export type CurrentTimeLineProps = {
  startHour: number
  baseWidth: number
  zoom: number
}

export const CurrentTimeLine: React.FC<CurrentTimeLineProps> = ({ startHour, baseWidth, zoom }) => {
  const [position, setPosition] = useState<number>(getTimelinePosition())

  function getTimelinePosition(): number {
    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    const hoursSinceStart = (currentHour - startHour) + (currentMinute / 60)

    // Return -1 if current time is before start hour (to hide the line)
    if (hoursSinceStart < 0) return -9999

    return hoursSinceStart * (baseWidth * zoom)
  }

  useEffect(() => {
    // Update position immediately and then every minute
    setPosition(getTimelinePosition())

    const intervalId = setInterval(() => {
      setPosition(getTimelinePosition())
    }, 60000)

    return () => clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startHour, baseWidth, zoom])

  if (position < 0) return null

  return (
    <StyledCurrentTimeLine $left={position}>
    </StyledCurrentTimeLine>
  )
}

const StyledCurrentTimeLine = styled('div', {
  shouldForwardProp: (prop) => prop !== '$left',
}) <{ $left: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${props => pxToRem(props.$left)};
  width: 2px;
  background-color: #f54C4C;
  z-index: 15;
  pointer-events: none;
  transition: left 0.5s ease-out;
`
